function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Cancel from '@material-ui/icons/Cancel';
import renderIf from '@signal/utils/renderIf';
import useFuzzySearch from '@signal/core-hooks/useFuzzySearch';
import { Input, StartAdornment, EndAdornment, SearchIcon } from './styles';
export function useFilteredList(list) {
  var _useState = useState(list.map(function (item, index) {
    return index;
  })),
      _useState2 = _slicedToArray(_useState, 2),
      searchResults = _useState2[0],
      setSearchResults = _useState2[1];

  var filteredList = useMemo(function () {
    return searchResults.map(function (itemIndex) {
      return list[itemIndex];
    }).filter(Boolean);
  }, [list, searchResults]);
  return [filteredList, setSearchResults];
}
export function FuzzySearchInput(props) {
  var _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Search...' : _props$placeholder,
      list = props.list,
      options = props.options,
      onSearch = props.onSearch,
      style = props.style,
      className = props.className,
      InputProps = props.InputProps,
      inputProps = props.inputProps,
      iconProps = props.iconProps;

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      query = _useState4[0],
      setQuery = _useState4[1];

  var searchResults = useFuzzySearch(list, query, options);
  var didMountRef = useRef(false);
  useEffect(function () {
    // only call `onSearch` callback if searchResults change after initial render
    if (didMountRef.current) {
      onSearch(searchResults.map(function (result) {
        return list.indexOf(result);
      }));
    } else {
      didMountRef.current = true;
    }
  }, [list, onSearch, searchResults]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    placeholder: placeholder,
    value: query,
    onChange: function onChange(event) {
      return setQuery(event.target.value);
    },
    InputProps: _objectSpread({
      startAdornment: /*#__PURE__*/React.createElement(StartAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(SearchIcon, Object.assign({
        color: "disabled"
      }, iconProps))),
      endAdornment: renderIf(query, /*#__PURE__*/React.createElement(EndAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return setQuery('');
        }
      }, /*#__PURE__*/React.createElement(Cancel, Object.assign({
        color: "disabled"
      }, iconProps)))))
    }, InputProps),
    inputProps: inputProps
  }));
}
export default /*#__PURE__*/memo(FuzzySearchInput);